import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { authClient } from "@core/clients";
import { ResetPasswordVariables } from "@core/types";

const useResetPasswordMutation = (options?: UseMutationOptions<any, any, ResetPasswordVariables>) =>
  useMutation(async ({ email, phone, newPassword, verificationCode, verificationCodeId }) => {
    const data = await authClient.resetPassword({ email, phone, newPassword, verificationCode, verificationCodeId });

    return data;
  }, options);

export default useResetPasswordMutation;
